import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=00af4bda&scoped=true&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"
import style0 from "./Video.vue?vue&type=style&index=0&id=00af4bda&lang=scss&scoped=true&rel=stylesheet%2Fscss&"
import style1 from "./Video.vue?vue&type=style&index=1&id=00af4bda&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00af4bda",
  null
  
)

export default component.exports